define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.random = exports.generateRandom = exports.round = void 0;
    function round(val, precision = 0) {
        const decimalPlaces = Math.pow(10, precision);
        return Math.round(decimalPlaces * val) / decimalPlaces;
    }
    exports.round = round;
    function generateRandom(low, high) {
        return Math.floor(Math.random() * (1 + high - low)) + low;
    }
    exports.generateRandom = generateRandom;
    function random(range = 999999) {
        return Math.round(Math.random() * range);
    }
    exports.random = random;
});
